import { ClearLocalStorage, GetLocalStorage } from '../components/commonClass/Session';
import { decrpt, decrptdata, encrypt, encryptedString } from '../components/enc_dec/enc_dec';
const Url = process.env.REACT_APP_API_URL

const encryptedQueryStringData = (endpoint: any) => {
    let queryStringData = endpoint?.split('?')[1]?.split('&')?.map((obj: any) => {
        let queryString = obj?.split('=')
        queryString[1] = encodeURIComponent(encrypt(isNaN(queryString[1]) ? queryString[1] : Number(queryString[1])))
        return [queryString[0], queryString[1]]?.join('=')
    })
    return endpoint?.split('?')?.length > 1 ? [endpoint?.split('?')[0], queryStringData?.join('&')]?.join('?') : endpoint
}

export async function verifytoken() {
    let status = false;
    try {
        let token: any = GetLocalStorage();
        const response = await fetch(Url + '/auth/v1/tokenVerify', {
            headers: { 'Authorization': `Bearer ${token.token}` }
        })
        if (response.status === 401 || response === undefined) {
            ClearLocalStorage();
            return status = false;
        }
        else {
            return status = true;
        }
    }
    catch (error) {
        ClearLocalStorage();
        status = false;
        return status;
    }
}

export async function getAllData(endpoint: any) {
    endpoint = encryptedQueryStringData(endpoint);
    try {
        let TAGData = [];

        let token: any = GetLocalStorage();
        const url = Url + endpoint;
        const response = await fetch(url, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Authorization': `Bearer ${token.token}`
            }
        });
        TAGData = await response.json();
        try {
            TAGData.data = TAGData?.data ? decrpt(TAGData?.data) : null
        } catch (error) {
            TAGData.data = TAGData?.data ? decrptdata(TAGData?.data) : null
        }
        return TAGData;
    }
    catch (error) {
        return [];
    }
}
export async function getData(endpoint: any) {
    endpoint = encryptedQueryStringData(endpoint);
    try {
        const url1 = Url + endpoint;
        const response = await fetch(url1);
        const TAGData = await response.json();
        try {
            TAGData.data = TAGData?.data ? decrpt(TAGData?.data) : null
        } catch (error) {
            TAGData.data = TAGData?.data ? decrptdata(TAGData?.data) : null
        }
        return TAGData;
    }
    catch (error) {
        return [];
    }
}
export async function getDataByPara(dataparam: any, getparam: any) {
    try {
        const urlparam = Url + dataparam;
        const getresponse = await fetch(urlparam,
            {
                method: 'POST', // or 'PUT'
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(encryptedString(encrypt(getparam))),

            });
        const getTAGData = await getresponse.json();
        try {
            getTAGData.data = getTAGData?.data ? decrpt(getTAGData?.data) : null
        } catch (error) {
            getTAGData.data = getTAGData?.data ? decrptdata(getTAGData?.data) : null
        }
        return getTAGData;
    }
    catch (error) {
        return [];
    }

}
export async function postUsersData(postsurl: any, postdata: any) {
    let PostTAGData = [];
    try {
        let token: any = GetLocalStorage();
        const posturl = Url + postsurl;
        const postresponse = await fetch(posturl,
            {
                method: 'POST', // or 'PUT'
                headers: {
                    'Authorization': `Bearer ${token.token}`,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(encryptedString(encrypt(postdata))),
            });
        PostTAGData = await postresponse.json();
        try {
            PostTAGData.data = PostTAGData?.data ? decrpt(PostTAGData?.data) : null
        } catch (error) {
            PostTAGData.data = PostTAGData?.data ? decrptdata(PostTAGData?.data) : null
        }
        return PostTAGData;
    }
    catch (error) {
        return [];
    }
}
export async function patchUsersData(patchsurls: any, patchdata: any) {
    let patchTAGData = [];

    try {
        let token: any = GetLocalStorage();
        const patchsurl = Url + patchsurls;
        const patchresponse = await fetch(patchsurl,
            {
                method: 'PATCH', // or 'PUT'
                headers: {
                    'Authorization': `Bearer ${token.token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(encryptedString(encrypt(patchdata))),
            });
        patchTAGData = await patchresponse.json();
        try {
            patchTAGData.data = patchTAGData?.data ? decrpt(patchTAGData?.data) : null
        } catch (error) {
            patchTAGData.data = patchTAGData?.data ? decrptdata(patchTAGData?.data) : null
        }
        return patchTAGData;
    }
    catch (error) {
        return [];
    }
}

export async function forgotPatchReq(patchsurls: any, patchdata: any) {
    try {
        const patchsurl = Url + patchsurls;
        const patchresponse = await fetch(patchsurl,
            {
                method: 'PATCH', // or 'PUT'
                headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
                body: JSON.stringify(encryptedString(encrypt(patchdata))),
            });
        const patchTAGData = await patchresponse.json();
        try {
            patchTAGData.data = patchTAGData?.data ? decrpt(patchTAGData?.data) : null
        } catch (error) {
            patchTAGData.data = patchTAGData?.data ? decrptdata(patchTAGData?.data) : null
        }
        return patchTAGData;
    }
    catch (error) {
        return [];
    }
}

export async function getOtpPostReq(postsurl: any, postdata: any) {
    try {
        const posturl = Url + postsurl;
        const postresponse = await fetch(posturl,
            {
                method: 'POST', // or 'PUT'
                headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
                body: JSON.stringify(encryptedString(encrypt(postdata))),
            });
        const PostTAGData = await postresponse.json();
        try {
            PostTAGData.data = PostTAGData?.data ? decrpt(PostTAGData?.data) : null
        } catch (error) {
            PostTAGData.data = PostTAGData?.data ? decrptdata(PostTAGData?.data) : null
        }
        return PostTAGData;
    }
    catch (error) {
        return [];
    }
}

export async function postDownloadVoucher(postsurl:any, postdata:any, travelCategoryId:any) {
    let voucherdata:any = [];
    try {
        let token:any = GetLocalStorage();
        const posturl = Url + postsurl;
        const postdownloadvoucherresponse = await fetch(posturl,
            {
                method: 'POST', // or 'PUT'
                headers: {
                    'Authorization': `Bearer ${token.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(encryptedString(encrypt(postdata))),
            });
        if (postdownloadvoucherresponse.headers.get("content-type")?.includes("application/json")) {
            voucherdata = await postdownloadvoucherresponse.json();
            try {
                voucherdata.data = voucherdata?.data ? decrpt(voucherdata?.data) : null
            } catch (error) {
                voucherdata.data = voucherdata?.data ? decrptdata(voucherdata?.data) : null
            }
        }
        else {
            voucherdata = await postdownloadvoucherresponse.blob();
            const url = window.URL.createObjectURL(voucherdata);
            const a = document.createElement("a");
            a.href = url;
            a.download = travelCategoryId === 1 ? "FlightVoucher.pdf" : "HotelVoucher.pdf";
            a.click();
            a.remove();
            voucherdata.status = true
        }

        return voucherdata;
    }
    catch (error) {
        return [];
    }
}